import React from "react"
import * as PIXI from "pixi.js"
import { NodeData } from "./Model/types"
import TreeGraph from "./TreeGraph"
import ScrollManager from "./ScrollManager"
import FontFaceObserver from "fontfaceobserver"

type OntologyProps = {
    nodeData: NodeData
}

type OntologyState = {}

export default class OntologyView extends React.Component<OntologyProps, OntologyState> {
    ref = React.createRef<HTMLDivElement>()
    app!: PIXI.Application
    treeGraph!: TreeGraph
    scrollManager!: ScrollManager

    constructor(props: OntologyProps) {
        super(props)

        const redHatText = new FontFaceObserver("Red Hat Text")
        redHatText.load().then(() => {
            console.log("Red Hat Text has loaded.")

            const courierPrime = new FontFaceObserver("Courier Prime")
            courierPrime.load().then(() => {
                console.log("Courier Prime has loaded")
                this.setupPIXI()
            })
        })
    }

    componentDidMount() {}

    setupPIXI() {
        console.log("setup PIXI")

        this.app = new PIXI.Application({
            // autoResize: true,
            width: 400,
            height: 400,
            backgroundColor: 0xf6f7fb,
            antialias: true,
            resolution: window.devicePixelRatio || 1,
        })
        this.ref.current?.appendChild(this.app.view)

        // create tree graph
        this.treeGraph = new TreeGraph(this.props.nodeData, this.app)
        this.app.stage.addChild(this.treeGraph)

        // create scroll manager
        this.scrollManager = new ScrollManager(this.app, this.treeGraph)

        // keep the view centered on a toggled node
        document.addEventListener("NodeWasToggled", ((e: CustomEvent) => {
            let clickDist = 0
            const clickX = e.detail.x
            this.treeGraph.didZoomChange = true
            this.treeGraph.layoutNodes(this.treeGraph.rootNode)
            clickDist = clickX - e.detail.targetX
            this.scrollManager.targetX += clickDist * this.treeGraph.scale.x
        }) as EventListener)

        this.onResize()

        // center the tree on the screen
        this.treeGraph.initLayout()
        this.scrollManager.initPosition()

        this.app.ticker.add((delta) => {
            this.scrollManager?.update()
            this.treeGraph.update()
        })
    }

    onResize = () => {
        this.app.renderer.resize(window.innerWidth, window.innerHeight)
    }

    render() {
        return <div ref={this.ref} className="ontology-view" />
    }
}
